import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/api';

// API module for fetching user data
export const accountApi = createApi({
  reducerPath: 'accountApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/account/',
  }),
  endpoints: builder => ({
    // Validate the verification token received to verify the user's email
    validateEmailToken: builder.mutation({
      query: token => ({
        url: 'verify-email',
        method: 'POST',
        data: { token },
      }),
    }),
  }),
});

export const { useValidateEmailTokenMutation } = accountApi;
